import React from 'react';
import { cn } from './cn';
import { Bezel } from './Bezel';

// Bento KPI card: eyebrow label, massive serif value, optional sub/trend line and icon.
export function StatCard({ label, value, sub, icon: Icon, accent = 'espresso', className }) {
    const accents = {
        espresso: 'text-espresso',
        sage: 'text-sage-deep',
        brass: 'text-brass-deep',
    };
    return (
        <Bezel className={cn('h-full p-6', className)}>
            <div className="flex items-start justify-between">
                <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-espresso-soft/70">{label}</span>
                {Icon && (
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-espresso/[0.05] text-espresso-soft">
                        <Icon size={18} weight="light" />
                    </span>
                )}
            </div>
            <div className={cn('mt-5 font-serif text-4xl leading-none tnum', accents[accent])}>{value}</div>
            {sub && <div className="mt-2 text-sm text-espresso-soft/80">{sub}</div>}
        </Bezel>
    );
}
